<div
  class="drag-drop"
  [ngClass]="{ 'drag-over': dragOver }"
  [formGroup]="parentForm"
>
  <div class="h-25-px">
    <app-text-title [level]="5" [text]="title"></app-text-title>
  </div>

  <div
    class="drag-zone d-flex flex-column align-items-center justify-content-center"
    *ngIf="!showProgressBar"
  >
    <div>Arrastra o selecciona un archivo</div>
    <div>
      <app-text-link
        (click)="openFileDialog()"
        [text]="'Seleccionar archivo'"
      ></app-text-link>
    </div>
    <input
      type="file"
      [formControl]="fieldControl"
      [id]="fileInputId"
      hidden
      accept=".pdf,image/jpeg"
      (change)="fileUpload($event.target.files)"
    />
  </div>

  <div
    class="m-t-18-px d-flex flex-column align-items-center justify-content-center"
    *ngIf="showProgressBar"
  >
    <div class="m-b-5-px w-100">
      <div class="w-80 float-left">
        <span class="text-extra-small">{{ fileName }}</span>
        <img
          class="ml-1"
          *ngIf="progressComplete"
          src="./assets/images/icons/check-circle.svg"
          alt="Icon success"
        />
        <img
          class="ml-1"
          *ngIf="progressError"
          src="./assets/images/icons/delete.svg"
          alt="Icon pen error"
        />
      </div>
      <div class="w-20 d-flex justify-content-end">
        <img
          src="./assets/images/icons/pen-write-red.png"
          alt="Icon pen write"
          (click)="restoreUploadFile()"
        />
      </div>
    </div>
    <div *ngIf="!progressComplete && !progressError" class="w-100">
      <app-progress-bar
        #progressBar
        [progress]="progress"
        (infoBarCompleteEvent)="infoBarComplete()"
      ></app-progress-bar>
    </div>
  </div>
</div>
